<template>
  <el-container class="energy-efficiency">
    <main-page v-if="loadMain" :system-info="systemConfig" :system-data="systemData" :default-menu-code1="selectedModuleCode1" :default-menu-code2="selectedModuleCode2"/>
  </el-container>
</template>

<script>
import MainPage from "../common/main/MainPage";
import {routerTo} from "../../router";

export default {
  name: 'EnergyEfficiency',
  components: {MainPage},
  data() {
    return {
      systemConfig: {
        id: this.GlobalConfig.ENERGY_EFFICIENCY_ID,
        type: this.GlobalConfig.MAIN_PAGE_TYPE_LEFT_RIGHT_TOP,
        name: this.GlobalConfig.ENERGY_EFFICIENCY_TITLE,
        icon: this.GlobalConfig.ENERGY_EFFICIENCY_ICON,
        icon1: this.GlobalConfig.ENERGY_EFFICIENCY_ICON1,
        menuIcons: this.GlobalConfig.ENERGY_EFFICIENCY_MENU_ICONS,
        menuColors: this.GlobalConfig.GREEN_MENU_COLORS,
        menuWarn: {
          value: 0,
          icon: 'zy-icon-info-notice',
          title: '最新告警',
          style: 'width: 20px;margin: 0;padding: 0;font-size: 18px;',
          method: this.openWarning
        }
      },
      systemData: {
        permission: [{childNode: []}], // 防止MainPage中出现‘未定义的属性’警告
        loginData: {}
      },
      selectedModuleCode1: '',
      selectedModuleCode2: '',
      timeStamp: 0,
      warnTimeout: null,
      loadMain: false
    }
  },
  created() {
    if (!sessionStorage.getItem('loginStore')) {
      routerTo(this.$router, 'LoginPage');
    } else {
      this.loadMain = true
      this.initData();
      this.getWarningNum();
      if (this.warnTimeout === null) {
        this.warnTimeout = setInterval(() => {
          this.getWarningNum();
        }, 1 * 60 * 1000);
      }
    }
  },
  destroyed() {
    if (this.warnTimeout !== null) {
      clearInterval(this.warnTimeout);
    }
  },
  methods: {
    initData() {
      /** start******** 测试大屏 *********/
      let loginStore = JSON.parse(sessionStorage.getItem("loginStore"));
      let testPermission = [];
      // if(loginStore.userInfo.userAccount === "admin") {
      //   testPermission[0] = {
      //     id: "test",
      //     name: "测试中",
      //     parentId: "root",
      //     childNode: [
      //       {
      //         id: "004",
      //         name: "PV大屏",
      //         parentId: "00",
      //         childNode: []
      //       },
      //       {
      //         id: "005",
      //         name: "PV数据",
      //         parentId: "00",
      //         childNode: []
      //       }
      //     ]
      //   }
      // }
      // loginStore.userInfo.permission[0] = {
      //   id: "00",
      //   name: "综合大屏",
      //   parentId: "root",
      //   childNode: [
      //     {
      //       id: "001",
      //       name: "能效大屏",
      //       parentId: "00",
      //       childNode: []
      //     },
      //     {
      //       id: "002",
      //       name: "数字大屏",
      //       parentId: "00",
      //       childNode: []
      //     },
      //     {
      //       id: "003",
      //       name: "站点大屏",
      //       parentId: "00",
      //       childNode: []
      //     }
      //   ]
      // }
      loginStore.userInfo.permission = testPermission.concat(loginStore.userInfo.permission)
      /** end******** 测试大屏 *********/
      this.systemData = loginStore.userInfo;
    },
    getWarningNum() {
      this.$api.energyMonitor.getAlarmNum().then(res => {
        this.systemConfig.menuWarn.value = res.data;
      });
    },
    openWarning() {
      // TODO 告警点击处理（先确定方式，跳转功能模块/弹窗显示）
      console.log('openWarning');
    }
  }
}
</script>

<style scoped>
.energy-efficiency{

}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyEfficiency.vue